module.exports = __webpack_public_path__ + "img/file4.ca6576f0.png";